export enum UtmSource {
  FluffyReferral = 'fluffyReferral',
}
